import styled from 'styled-components';

export const StyledLazyImage = styled.img`
  opacity: ${(props) => (props.$isLoaded ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;
